'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TargetingRuleSourceTypes = require('../constants/TargetingRuleSourceTypes');

var _TargetingRuleMatchTypes = require('../constants/TargetingRuleMatchTypes');

var _TargetingRuleTypes = require('../constants/TargetingRuleTypes');

exports.default = (0, _immutable.Record)({
  matchType: _TargetingRuleMatchTypes.CONTAINS,
  matchValue: null,
  queryParam: null,
  sourceType: _TargetingRuleSourceTypes.URL,
  type: _TargetingRuleTypes.INCLUDE
}, 'TargetingRule');
module.exports = exports['default'];